




























































































import { mapGetters } from 'vuex';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { truncateString } from '@/helpers/formatString';
import * as vr from '@/helpers/validation';
import {
  getStreamerFraudReportsList,
  getStreamerFraudReportsUnreadCount,
  updateStreamerFraudReportReadStatus
} from '@/api/CopyStake/StreamerFraudReports';
import {
  EReasonFraudReportType,
  EStreamingType,
  IMenuFilterGroupsConfig,
  IStreamerFraudReport,
  IStreamerFraudReportFiltersParams,
  IStreamerFraudReportListParams,
  ValidationRules
} from '@/api/schema';

const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const CopyBtn = (): Promise<any> => import('@/components/core/CopyBtn.vue');
const ImagePreviewDialog = (): Promise<any> =>
  import('@/components/ImagePreviewDialog.vue');
const VMenuFilterGroups = (): Promise<any> =>
  import('@/components/VMenuFilterGroups.vue');

const streamerTypeMap = {
  [EStreamingType.WHIP]: {
    label: 'Streamer',
    type: 'transparent-primary'
  },
  [EStreamingType.WEB]: {
    label: 'BaS',
    type: 'transparent-gray'
  }
};

const reasonsTypeMap = {
  [EReasonFraudReportType.CHEATING]: {
    label: 'Cheating',
    type: 'primary'
  },
  [EReasonFraudReportType.SCAMMING]: {
    label: 'Scamming or Fraud',
    type: 'additional-pending'
  },
  [EReasonFraudReportType.HARASSMENT]: {
    label: 'Harassment or Hate Speech',
    type: 'additional-purple'
  },
  [EReasonFraudReportType.INAPPROPRIATE]: {
    label: 'Inappropriate Behavior',
    type: 'additional-finished'
  },
  [EReasonFraudReportType.SPAM]: {
    label: 'Spam or Misleading Behavior',
    type: 'additional-deleted'
  }
};

const DEFAULT_PAGINATION_OPTIONS = {
  page: 1,
  itemsPerPage: 10,
  sortBy: ['createdAt'],
  sortDesc: [true]
} as const;

export default {
  name: 'CopyStakeStreamerFraudReportsTable',
  components: {
    VStatus,
    ImagePreviewDialog,
    VMenuFilterGroups,
    CopyBtn
  },
  props: {
    unreadReportsCount: {
      type: Number,
      default: 0
    }
  },
  data(): Record<string, unknown> {
    return {
      streamerTypeMap,
      reasonsTypeMap,

      tmpFiltersOptions: null,
      filtersOptions: null,
      tmpSearchPhrase: '',
      searchPhrase: '',

      isLoading: false,
      list: [] as IStreamerFraudReport[],
      total: null,
      tableOptions: { ...DEFAULT_PAGINATION_OPTIONS },

      dialogs: {
        imagePreview: false,
        loading: false,
        data: undefined
      },

      headers: [
        { text: 'Date', value: 'createdAt', width: 110 },
        { text: 'Streamer Type', value: 'streamerType', width: 110 },
        { text: "Streamer's Nickname", value: 'streamerNickname' },
        { text: 'Reason', value: 'reason' },
        { text: 'Comment', value: 'comment', width: '400' },
        {
          text: 'Screenshots',
          value: 'image',
          width: 110,
          sortable: false,
          align: 'center'
        },
        {
          text: 'Action',
          value: 'actions',
          width: 80,
          sortable: false,
          align: 'center'
        }
      ],

      filtersConfig: [
        {
          title: "Streamer's Type",
          type: 'streamerTypes',
          filterItems: [
            { text: 'BaS', value: EStreamingType.WEB },
            { text: 'Streamer', value: EStreamingType.WHIP }
          ]
        },
        {
          title: 'Reason',
          type: 'reasons',
          filterItems: [
            { text: 'Cheating', value: EReasonFraudReportType.CHEATING },
            {
              text: 'Scamming or Fraud',
              value: EReasonFraudReportType.SCAMMING
            },
            {
              text: 'Harassment or Hate Speech',
              value: EReasonFraudReportType.HARASSMENT
            },
            {
              text: 'Inappropriate Behaviour',
              value: EReasonFraudReportType.INAPPROPRIATE
            },
            {
              text: 'Spam or Misleading Behavior',
              value: EReasonFraudReportType.SPAM
            }
          ]
        },
        {
          title: 'Status',
          type: 'readFlags',
          filterItems: [
            { text: 'Read', value: true },
            { text: 'Unread', value: false }
          ]
        }
      ] as IMenuFilterGroupsConfig[]
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    rules(): ValidationRules {
      return {
        searchPhrase: [(v) => (v ? vr.minLength(v, 3) : true)]
      };
    },
    modifiedFilters(): IStreamerFraudReportFiltersParams {
      return {
        ...(this.searchPhrase ? { nickname: this.searchPhrase } : {}),
        ...(this.filtersOptions?.streamerTypes
          ? { streamerTypes: this.filtersOptions.streamerTypes }
          : {}),
        ...(this.filtersOptions?.reasons
          ? { reasons: this.filtersOptions.reasons }
          : {}),
        ...(this.filtersOptions?.readFlags
          ? { readFlags: this.filtersOptions.readFlags }
          : {})
      };
    },
    requestParams(): IStreamerFraudReportListParams {
      return {
        ...this.modifiedFilters,
        size: this.tableOptions.itemsPerPage,
        page: this.tableOptions.page - 1,
        sort: this.tableOptions.sortBy[0],
        order: this.tableOptions.sortDesc[0] ? 'DESC' : 'ASC',
        operatorId: this.operatorId
      };
    }
  },
  watch: {
    requestParams: {
      async handler(): Promise<void> {
        await this.fetchStreamerReportsData();
      },
      deep: true
    }
  },
  methods: {
    truncateString,

    handleClickClearSearchInput(): void {
      this.updateSearchOptions();
    },
    handleKeydownEnterSearchInput(): void {
      this.updateSearchOptions(this.tmpSearchPhrase);
    },
    handleClickSearchButton(): void {
      this.updateSearchOptions(this.tmpSearchPhrase);
    },
    handlerClickReadReportButton(report: IStreamerFraudReport): void {
      this.updateStreamerReportReadStatus(report);
    },
    handlerOpenGameImagePreviewDialog(imageUrl?: string): void {
      if (!imageUrl) {
        return;
      }

      this.dialogs.imagePreview = true;
      this.dialogs.data = { imageUrl };
    },

    updateFilter(): void {
      this.filtersOptions = { ...this.tmpFiltersOptions };

      this.resetTableOptions();
    },
    updateSearchOptions(phrase: string = ''): void {
      const searchInput = this.$refs.searchInput;
      searchInput.validate();

      this.$nextTick((): void => {
        if (searchInput.valid) {
          this.searchPhrase = phrase ?? '';

          this.resetTableOptions();
        }
      });
    },
    resetTableOptions(): void {
      this.tableOptions.page = DEFAULT_PAGINATION_OPTIONS.page;
      this.tableOptions.itemsPerPage =
        DEFAULT_PAGINATION_OPTIONS.itemsPerPage;
    },

    async fetchUnreadReportsCount(): Promise<void> {
      try {
        const unreadCount = await getStreamerFraudReportsUnreadCount();

        this.$emit('update:unreadReportsCount', unreadCount);
      } catch (error) {
        errorToastMessage(error);
        this.$emit('update:unreadReportsCount', 0);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchStreamerReportsData(): Promise<void> {
      if (!this.operatorId) return;

      try {
        this.isLoading = true;

        const { content, totalElements } = await getStreamerFraudReportsList(
          this.requestParams
        );

        this.list = content;
        this.total = totalElements;

        await this.fetchUnreadReportsCount();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateStreamerReportReadStatus(
      report: IStreamerFraudReport
    ): Promise<void> {
      try {
        report.read = true;

        await updateStreamerFraudReportReadStatus(report.id);
        await this.fetchUnreadReportsCount();

        this.$toast.success('Report was marked as read.');
      } catch (error) {
        errorToastMessage(error);
        await this.fetchStreamerReportsData();
      }
    },

    getRowClass(item: IStreamerFraudReport): string {
      return item.read ? 'read-row' : 'unread-row';
    },

    closeDialog(type: string): void {
      this.dialogs[type] = false;

      this.$nextTick(() => {
        this.dialogs.data = {};
      });
    }
  }
};
